import React from "react";
import moment from "moment";
import FilterTableViewV2 from "../../../views/FilterTableViewV2";
import { ALL_JOB_SWMS_URL } from "../../../../../dataProvider/constant";
import v2Styles from "../../../v2Styles.module.css";
import styles from "../JobSwmsTask/SwmsResendConfirmModal.module.css";
import { Typography } from "@mui/material";

const dateFormatter = (v) => moment.utc(v).format("DD/MM/YYYY hh:mm A");

const arrowRight = (
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ width: "14px", height: "14px", margin: "0px 5px", verticalAlign: "-0.2em" }} fill="currentColor">
      <path fill="currentColor" d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z" />
    </svg>
  </span>
)

const customValueView = (key, value, rowData) => {
  return (
    <div>
      <Typography className={v2Styles.TableText} noWrap>{rowData.old_value} {rowData.old_value && rowData.new_value ? arrowRight : ""} {rowData.new_value}</Typography>
    </div>
  )
}

const tableConfig = {
  apiEndPoint: ALL_JOB_SWMS_URL,
  filters: [],
  dataTable: {
    pagination: {
      text: "Histories",
      pageSize: 10
    },
    columns: [
      { columnName: "Action", keyName: "action", width: "10%" },
      { columnName: "Sections", keyName: "section", width: "20%" },
      { columnName: "New Value", keyName: "value", width: "40%", customView: customValueView },
      { columnName: "Who", keyName: "who", width: "12%" },
      { columnName: "When", keyName: "when", width: "13%", getValue: (val) => val ? dateFormatter(val) : '' },
    ],
  }
}

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" className={styles.closeBtnIcon}>
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z" />
  </svg>
);

export default function VersionHistoryRecordsModal({ swmsId, jobId, swmsName, swmsNumber, version, onClose, onSuccess }) {

  const formName = swmsName || "SWMS";
  const formNumber = version.versionNumber ? `V${version.versionNumber}` : "-";

  return (
    <div className={styles.overlay} onClick={() => onClose()}>
      <div className={styles.modal} style={{ width: "1200px", maxWidth: "80vw" }} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h3>Version History</h3>
            <p className={styles.headerSubtitle}>{formName} · {formNumber}</p>
          </div>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            type="button"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>

        <div className={styles.body}>
          <FilterTableViewV2 configData={{
            ...tableConfig,
            apiEndPoint: `${tableConfig.apiEndPoint}/${jobId}/${swmsId}/edit-history`,
            fetchParams: [{
              key: "version", value: version.versionNumber
            }],
          }} />
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}